type footerDataCheck = Array<string>;

export const footerData: footerDataCheck = [
  "facebook", "github", "linkedin"
];